import { Inject, Injectable, Optional } from '@angular/core';
import type { Response } from 'express';
import { RESPONSE } from '../../../express.tokens';

/**
 * Sets the HTTP status of the server-rendered response. RESPONSE is only
 * provided by server.ts, so in the browser every call is a no-op.
 */
@Injectable({ providedIn: 'root' })
export class HttpStatusService {
  constructor(@Optional() @Inject(RESPONSE) private res: Response | null) { }

  notFound() {
    this.res?.status(404);
  }

  /** Real HTTP redirect for crawlers; the SSR body is ignored by clients. */
  redirect(location: string, code: 301 | 302 = 302) {
    if (!this.res || this.res.headersSent) { return; }
    this.res.status(code);
    this.res.setHeader('Location', location);
  }
}
